export enum ANIMATION_STATE {
  IDLE = "idle",
  ENTERING = "entering",
  PULSING = "pulsing",
}

const PULSE_DURATION_OUT = 0.5;
const PULSE_DURATION_HOLD = 1.5;
const PULSE_DURATION_IN = 0.5;
const PULSE_DURATION_HOLD_BIG = 0;
const PULSE_CYCLES_ENTERING = 4;

const PULSE_CYCLE_DURATION =
  PULSE_DURATION_HOLD +
  PULSE_DURATION_IN +
  PULSE_DURATION_HOLD_BIG +
  PULSE_DURATION_OUT;

const TOTAL_ENTERING_PULSE_DURATION =
  PULSE_CYCLE_DURATION * PULSE_CYCLES_ENTERING;

export const ANIMATION_CONFIG = {
  ENTER_DURATION: 0.5,
  EXIT_DURATION: 0.4,
  BASE_DELAY: 0.1,
  BONUS_TEXT_Y_SHIFT_OUT: 8,
  PULSE_DURATION_OUT,
  PULSE_DURATION_HOLD,
  PULSE_DURATION_IN,
  PULSE_DURATION_HOLD_BIG,
  PULSE_CYCLES_ENTERING,
  PULSE_CYCLE_DURATION,
  TOTAL_ENTERING_PULSE_DURATION,
};

export const LOOP_CONFIG = {
  INITIAL_DELAY: 1000,
  RESET_DELAY: 1000,
  PULSE_HOLD_DELAY: 1000,
  COIN_BURST_DELAY: 500, // Start coins 0.5s after pulsing begins (coins will burst as text reaches top)
};
